import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Merge: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm8 6 4-4 4 4' }],
    ['path', { d: 'M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22' }],
    ['path', { d: 'm20 22-5-5' }],
  ],
];

export default Merge;
